import theme from '../../theme/theme';
import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  CardMedia,
  List,
  ListItem,
  ListItemText,
  Chip,
} from "@mui/material";
import { Star, CheckCircle } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Shape from "../common/Shape";

const Hero = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      id="home"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: `linear-gradient(135deg, #e6f0ff 0%, #ffffff 100%)`,
        color: theme.palette.primary.main,
        position: "relative",
        pt: { xs: 2, md: 24 },
        pb: { xs: 6, md: 12 },
        overflow: "hidden",
      }}
    >


      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <>
          <Shape
            color={theme.palette.secondary.main}
            size={isMobile ? 300 : 400}
            position={
              isMobile
                ? { top: "90%", left: "50%" } 
                : { top: "25%", left: "1100px" }}
            rotation={0}
          />
          <Shape
            color={theme.palette.secondary.main}
            size={isMobile ? 300 : 300}
            position={
              isMobile
                ? { top: "70%", left: "25%" } 
                : { top: "25%", left: "900px" }
            }
            rotation={0}
          />
          <Shape
            color={theme.palette.secondary.main}
            size={isMobile ? 300 : 400}
            position={
              isMobile
                ? { top: "60%", left: "60%" }
                : { top: "0%", left: "1000px" }
            }
            rotation={0}
          />
        </>

        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={7} order={{ xs: 2, md: 1 }}>
            <Chip
              label="IT Services & Solutions"
              color="secondary"
              sx={{
                px: 1.9,
                fontWeight: 800,
                boxShadow: `0 0 10px ${theme.palette.secondary.main}`,
                color: "#ffffff",
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                mb: { xs: 0, md: 3 },
              }}
            />
            <Typography variant="h1" gutterBottom sx={{
              pt: 2,
              fontSize: {
                xs: "clamp(1.6rem, 2.56vw, 2.3rem)",
                sm: "clamp(1.8rem, 2.78vw, 2.5rem)",
                md: "clamp(2.5rem, 3.89vw, 3.5rem)",
              },
              mb: { xs: 3, md: 2 },
            }} component="div">
              We Build{" "}
              <Box component="span" sx={{ color: theme.palette.secondary.main }}>
                Websites & Digital Tools
              </Box>{" "}
              That Grow Your Business
            </Typography>
            <Typography
              variant="h5"
              sx={{
                mb: { xs: 8, md: 3 },
                fontWeight: 300,
                color: theme.palette.primary.light,
                fontSize: {
                  xs: "clamp(0.75rem, 2vw, 0.8125rem)",
                  md: "clamp(1rem, 2.8vw, 1.25rem)",
                },
              }}
              component="div"
            >
              We are a young development startup helping individuals & businesses
              get online with modern websites, custom tools, and digital
              solutions
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                pt: 0,
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={() =>
                  document.getElementById("services").scrollIntoView({ behavior: "smooth" })
                }
                sx={{
                  px: { xs: 16, md: 7 },
                  fontSize: {
                    xs: "clamp(0.8125rem, 2vw, 0.875rem)",
                    md: "clamp(0.875rem, 2.3vw, 1rem)",
                  },
                  fontWeight: 700,
                  borderWidth: 2,
                }}
              >
                Our Services
              </Button>
              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={() =>
                  document.getElementById("contact").scrollIntoView({ behavior: "smooth" })
                }
                sx={{
                  px: { xs: 13, md: 7 },
                  fontWeight: 700,
                  fontSize: {
                    xs: "clamp(0.8125rem, 2vw, 0.875rem)",
                    md: "clamp(0.875rem, 2.3vw, 1rem)",
                  },
                  borderWidth: 2,
                  color: theme.palette.primary.main,
                  borderColor: theme.palette.primary.main,
                  "&:hover": {
                    borderWidth: 2,
                    backgroundColor: "rgba(26, 58, 111, 0.05)",
                  },
                }}
              >
                Contact For Join Us
              </Button>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={5}
            order={{ xs: 1, md: 2 }}
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <Box
              sx={{
                position: "relative",
                borderRadius: 5,
                overflow: "hidden",
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                border: `1px solid ${theme.palette.primary.light}`,
                width: "100%",
                height: "500px",
                maxHeight: "100%",
              }}
            >
              <CardMedia
                component="img"
                image="https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt="Modern web development and IT solutions by SAINI COLLECTION"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform 0.5s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "linear-gradient(to top, rgba(26,58,111,0.9) 0%, transparent 100%)",
                  color: "#fff",
                  p: 4,
                }}
              >
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    color: "#ffffff",
                    fontSize: "2rem",
                  }}
                >
                  <Star sx={{ mr: 1 }} />
                  Why Choose Us?
                </Typography>
                <List>
                  {[
                    "Modern & Clean Design — Websites that look professional & fresh.",
                    "Full Stack Expertise — Frontend & Backend, everything covered.",
                    "Affordable & Transparent — No hidden costs, clear pricing.",
                    "Support & Growth — We grow with you, whenever you need us.",
                  ].map((item, index) => (
                    <ListItem key={index} sx={{ px: 0, py: 0.5 }}>
                      <CheckCircle
                        sx={{
                          fontSize: 18,
                          color: theme.palette.secondary.main,
                          mr: 1.5,
                        }}
                      />
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{
                          variant: "body1",
                          fontWeight: 300,
                          color: "#ffffff",
                          fontSize: "1rem",
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;
